import { render, staticRenderFns } from "./application-form-review.vue?vue&type=template&id=36a21fe9&scoped=true&"
import script from "./application-form-review.vue?vue&type=script&lang=js&"
export * from "./application-form-review.vue?vue&type=script&lang=js&"
import style0 from "./application-form-review.vue?vue&type=style&index=0&id=36a21fe9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a21fe9",
  null
  
)

export default component.exports